export default {"src":"/_next/static/media/close-white.fb1943d1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};